export function ratio(x, y) {
    return x/y*100;
}